import { render, staticRenderFns } from "./doviz.vue?vue&type=template&id=3e682fa5&scoped=true"
import script from "./doviz.vue?vue&type=script&lang=js"
export * from "./doviz.vue?vue&type=script&lang=js"
import style0 from "./doviz.vue?vue&type=style&index=0&id=3e682fa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e682fa5",
  null
  
)

export default component.exports